import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import CouponScrollBox from '../../pages/subscription/coupon-scroll-box';
import DiscountCoupon from '../../pages/subscription/discount-coupon';
import Voucherify from '../../../helpers/voucherify-helper';
import { VOUCHER_CATEGORIES } from '../../../../isomorphic/constants';
import './apply-voucher.m.css';

class ApplyVoucher extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      couponCode: '',
      invalid: false,
      coupons: []
    };
    this.handleInvalidCoupon = this.handleInvalidCoupon.bind(this);
    this.onChangeCouponInput = this.onChangeCouponInput.bind(this);
    this.setLoading = this.setLoading.bind(this);
    this.showPreviousScreen = this.showPreviousScreen.bind(this);
  }
  componentDidMount() {
    Voucherify.getVouchers()
      .then(response => {
        this.setState({
          coupons: (response.payload && this.filterMicroVouchers(response.payload.data)) || []
        });
      })
      .catch(error => {
        console.error(error);
      });
  }

  filterMicroVouchers(vouchers) {
    return vouchers.filter(
      voucher =>
        voucher.category === VOUCHER_CATEGORIES.MICRO || voucher.category === VOUCHER_CATEGORIES.ALL
    );
  }
  handleInvalidCoupon() {
    this.setState(
      {
        couponCode: '',
        isLoading: false,
        invalid: true
      },
      () => this.props.setAppliedCoupon(null)
    );
  }

  onChangeCouponInput(value) {
    this.setState({
      couponCode: value
    });
  }

  setLoading(callback) {
    this.setState(
      {
        isLoading: true
      },
      callback
    );
  }

  showPreviousScreen() {
    this.props.showPaymentOption();
  }

  render() {
    const { appliedCoupon = {}, selectedPlan, setAppliedCoupon } = this.props;
    return (
      <React.Fragment>
        <div styleName="micropayment-wrapper" id="micropayment_wrapper">
          <div styleName="left-arrow" onClick={this.showPreviousScreen} />
          <div styleName="discountCoupon-wrapper">
            {appliedCoupon ? (
              <div styleName="applied-coupon">
                <p styleName="coupon-display">
                  {get(appliedCoupon, ['discount_details', 'code'])} APPLIED
                </p>
                <button styleName="clearBtn" onClick={() => setAppliedCoupon(null)} />
              </div>
            ) : (
              <DiscountCoupon
                theme="white"
                appliedCoupon={appliedCoupon}
                handleInvalidCoupon={this.handleInvalidCoupon}
                selectedPlanId={selectedPlan.id}
                setAppliedCoupon={setAppliedCoupon}
                isLoading={this.state.isLoading}
                couponCode={this.state.couponCode}
                invalid={this.state.invalid}
                onChangeCouponInput={this.onChangeCouponInput}
                setLoading={this.setLoading}
              />
            )}
          </div>
          {this.state.coupons.length ? (
            <CouponScrollBox
              coupons={this.state.coupons}
              theme
              appliedCoupon={appliedCoupon}
              selectedPlan={selectedPlan}
              handleInvalidCoupon={this.handleInvalidCoupon}
              setAppliedCoupon={setAppliedCoupon}
            />
          ) : (
            <div styleName="empty-box" />
          )}
        </div>
      </React.Fragment>
    );
  }
}
ApplyVoucher.propTypes = {
  showPaymentOption: PropTypes.func.isRequired,
  setAppliedCoupon: PropTypes.func.isRequired,
  selectedPlan: PropTypes.object.isRequired,
  coupons: PropTypes.array.isRequired,
  appliedCoupon: PropTypes.object
};
export default ApplyVoucher;
